import {Component, Attribute, Injectable} from "@angular/core";
import {Http} from "@angular/http";
import {Observable} from "rxjs/Observable";

@Component({
  selector: "usecase-content",
  template: `<div class="container"><ng-content></ng-content></div>`,
  styles: [`
  div.container {
    border: 1px solid #2e2e2e;
    padding: 5px;
    margin: 10px 0;
  }
`]
})
export class UseCaseContent {
}

@Injectable()
export class UseCaseSource {
  private _cache: { [key: string]: string };

  constructor(private http: Http) {
    this._cache = {};
  }

  get(path: string): Promise<string> {
    if (path in this._cache) {
      return Promise.resolve(this._cache[path]);
    }
    let srcUrl = `script/${path}/component.ts`;
    return this.http.get(srcUrl)
      .toPromise()
      .then(resp => {
        this._cache[path] = resp.text();
        return this._cache[path];
      })
      .catch(error => {
        return error.toString();
      });
  }
}

@Component({
  selector: "usecase-container,[usecase-container],.usecase-container",
  template: `
<div class="container">
  <h3 class="title">{{title}}</h3>
  <ng-content select="usecase-content"></ng-content>
  <div class="code">
    <span class="src">// {{srcUrl}}</span><br>
    <pre><code>{{code}}</code></pre>
  </div>
</div>
   `,
  styles: [require("./component.css").toString()]
})
export class UseCaseContainer {
  private code: string;
  private srcUrl: string;

  constructor(
    @Attribute("src") private src: string,
    @Attribute("title") private title: string,
    private source: UseCaseSource) {
  }

  ngOnInit() {
    this.srcUrl = `script/${this.src}/component.ts`;
    this.source.get(this.src)
      .then(code => {
        this.code = code;
      });
  }
}



/** WEBPACK FOOTER **
 ** ./script/shared/usecase/component.ts
 **/